var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"customizedFont",staticStyle:{"background":"#EBECF0"},attrs:{"id":"app"}},[[_c('sidebar')],_c('v-main',[_c('v-container',[_c('router-view')],1)],1),[_c('black-footer')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }